import { render, staticRenderFns } from "./TippArrowNavigation.vue?vue&type=template&id=82d7d696&scoped=true&"
import script from "./TippArrowNavigation.vue?vue&type=script&lang=js&"
export * from "./TippArrowNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TippArrowNavigation.vue?vue&type=style&index=0&id=82d7d696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d7d696",
  null
  
)

export default component.exports